// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"536":"15e4cc98d6d3d25a","561":"a20d019b2938d97b","923":"1dd81230a0547b87"}[chunkId] + ".js";
};